/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';
/**
 * Ответ на регистрацию: требуется подтверждение e-mail кодом.
 * @export
 * @interface RegisterResult
 */
export interface RegisterResult {
    userId?: string | null;
    email?: string | null;
    requiresConfirmation?: boolean;
    cooldownSecondsLeft?: number;
    /** Заполняются только когда подтверждение e-mail отключено настройкой (requiresConfirmation=false) — тогда регистрация сразу логинит пользователя. */
    apiToken?: string | null;
    refreshToken?: string | null;
}

export function RegisterResultFromJSON(json: any): RegisterResult {
    return RegisterResultFromJSONTyped(json, false);
}

export function RegisterResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'requiresConfirmation': !exists(json, 'requiresConfirmation') ? undefined : json['requiresConfirmation'],
        'cooldownSecondsLeft': !exists(json, 'cooldownSecondsLeft') ? undefined : json['cooldownSecondsLeft'],
        'apiToken': !exists(json, 'apiToken') ? undefined : json['apiToken'],
        'refreshToken': !exists(json, 'refreshToken') ? undefined : json['refreshToken'],
    };
}

export function RegisterResultToJSON(value?: RegisterResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'email': value.email,
        'requiresConfirmation': value.requiresConfirmation,
        'cooldownSecondsLeft': value.cooldownSecondsLeft,
        'apiToken': value.apiToken,
        'refreshToken': value.refreshToken,
    };
}
